import type { TMarket } from '../market/types';
import { LINK_ACTIONS } from './constants';
import type { TWordpressFabricFooterTranslationsTextLink } from './types';

export const getUniqueTimestamp = () => {
    const now = new Date();
    const minutes = now.getMinutes();
    const roundedMinutes = Math.floor(minutes / 5) * 5; // Round down to the nearest 5-minute interval
    now.setMinutes(roundedMinutes);
    now.setSeconds(0);
    now.setMilliseconds(0);
    return now.getTime();
};

export const getAction = (url: string | undefined) => {
    if (url?.startsWith('action')) {
        const actionName = url.replace('action:', '');

        return LINK_ACTIONS[actionName];
    }

    return undefined;
};

export const processUrl = (url: string | undefined, market: TMarket) => {
    if (url?.startsWith('action')) {
        return '';
    }
    return url?.replace('{market}', market.slug);
};

export const footerLinkMapper =
    (market: TMarket) => (link: TWordpressFabricFooterTranslationsTextLink) => {
        return {
            label: link?.label || '',
            link: processUrl(link?.link, market) || '',
            action: getAction(link?.link),
            external: link?.external === 'true',
            enabled: link?.enabled === 'true'
        };
    };
